import React, { useContext, useEffect, useState } from 'react';
import Avatar from 'react-avatar';
import AccountBg from '../../assets/profile-bg.png';
import { ActiveMember, CurrentUserDetails } from '../../context';
import SSButton from '../SSButton';
import './editmember.scss';
import { DOMAIN } from '../../Constants/base';
import { deleteReq, postReq } from '../../utils/api';
import { toast } from 'react-toastify';
import { postLogger } from '../../utils/analytics';
import SSProductItem from '../SSProductItem';
import { getSessionStorage, setSessionStorage } from '../../utils';
import { trackEvents } from '../../utils/analytics';

export default function EditMember({ setEditMemberPopUp, availableTeamPlans, getTeamMembers }) {
  const userToken = JSON.parse(localStorage.getItem('ss-auth-sales')) || {};
  const profilesSession = getSessionStorage('current-profile');

  const [editMember, dispatchEditMember] = useContext(ActiveMember);
  const [profile, profileDispatch] = useContext(CurrentUserDetails);

  const [isDisabledBtn, setIsDisabledBtn] = useState(true);
  const [userProductList, setUserProductList] = useState([...editMember.subscriptions]);
  const [allPlans, setAllPlans] = useState([...availableTeamPlans]);
  const [isClickedOnce, setIsClickedOnce] = useState(false);
  const [previousUserPlans, setPreviousPlans] = useState([...editMember.subscriptions]);
  const [currentClickedItem, setCurrentClickedItem] = useState(null);

  useEffect(() => {
    setAllPlans(availableTeamPlans);
  }, [availableTeamPlans]);

  useEffect(() => {
    if (userProductList.length === 0) {
      if (previousUserPlans.length) {
        let newUpdates = allPlans.map((item) => {
          if (previousUserPlans.some((prd) => prd.product.id === item.id)) {
            return { ...item, isDisabled: false };
          } else {
            return { ...item, isDisabled: true };
          }
        });
        setAllPlans(newUpdates);
      } else setIsClickedOnce(false);
    }
    if (userProductList.length && isClickedOnce) {
      let updatingAllTeamPlans = allPlans.map((item) => {
        if (item.id === currentClickedItem.id) {
          return { ...item, isDisabled: false };
        }
        if (userProductList.some((prod) => prod.product.id === item.id)) {
          if (previousUserPlans.some((prod) => prod.product.id === item.id)) {
            return { ...item, isDisabled: true };
          } else {
            return { ...item, isDisabled: false };
          }
        } else {
          return { ...item, isDisabled: true };
        }
      });
      setAllPlans(updatingAllTeamPlans);
    }
    // check for previous state
    if (previousUserPlans.length === userProductList.length) {
      let updatingAllTeamPlans = [...allPlans];
      updatingAllTeamPlans.forEach((item) => delete item['isDisabled']);
      setAllPlans(updatingAllTeamPlans);
    }
  }, [userProductList]);

  useEffect(() => {
    if (!isClickedOnce) {
      let updatingAllTeamPlans = [...allPlans];
      updatingAllTeamPlans.forEach((item) => delete item['isDisabled']);
      setAllPlans(updatingAllTeamPlans);
    }
  }, [isClickedOnce]);

  const isToolActivated = (plan) => {
    return userProductList.some((prod) => prod.product.id === plan);
  };

  const handleItemClicked = (prodClicked) => {
    setCurrentClickedItem({ ...prodClicked });
    setIsClickedOnce(true);
    setIsDisabledBtn(false);

    let isAlreadyClicked = userProductList.some((prod) => prod.product.id === prodClicked.id);
    if (isAlreadyClicked) {
      let filtredArray = userProductList.filter((prod) => prod.product.id !== prodClicked.id);
      setUserProductList(filtredArray);
    } else setUserProductList([...userProductList, { product: prodClicked }]);
  };

  const removeTeamMember = async () => {
    let url = `${DOMAIN}/v1/stripe/user/remove/${editMember.id}`;
    let requestHeaders = {
      authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
    };
    const response = await deleteReq({ url, requestHeaders });
    const { code, data } = response;
    let timeoutCode = code.toString();
    timeoutCode = Array.from(timeoutCode)[0];
    if (code === 200) {
      toast.success(data.message, {
        position: 'top-center',
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
      setEditMemberPopUp(false);
      getTeamMembers();
    } else if (timeoutCode === '5') {
      let newPayload = {
        memberId: editMember.id,
        code,
      };
      postLogger('REMOVE_TEAM_MEMBER', newPayload);
    }
  };

  const getChangedProductId = () => {
    let status = {
      type: 'subscribe',
      product: null,
    };
    // get the added product id
    if (userProductList.length > previousUserPlans.length) {
      let productUpdated = userProductList.filter(
        (curr) => !previousUserPlans.some((prev) => prev.product.id === curr.product.id)
      );
      productUpdated = productUpdated[0];
      status = {
        ...status,
        product: productUpdated.product ? productUpdated.product : productUpdated,
      };
    }
    // get removed product
    if (previousUserPlans.length > userProductList.length) {
      let productUpdated = previousUserPlans.filter(
        (prev) => !userProductList.some((curr) => curr.product.id === prev.product.id)
      );
      productUpdated = productUpdated[0];

      status = {
        ...status,
        type: 'unsubscribe',
        product: productUpdated.product ? productUpdated.product : productUpdated,
      };
    }
    return status;
  };

  const updateProductsSubscription = async () => {
    if (isDisabledBtn) return;
    setIsDisabledBtn(true);

    let url = `${DOMAIN}/v1/stripe/user/create-checkout-session`;
    let requestHeaders = {
      authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
    };
    let newProduct = getChangedProductId();
    if (!newProduct?.product?.id) {
      setEditMemberPopUp(false);
      setIsDisabledBtn(false);
      return;
    }

    if (newProduct.type === 'unsubscribe') {
      url = `${DOMAIN}/v1/stripe/user/unsubscribe`;
    }
    let payload = {
      productId: newProduct.product.id,
      memberId: editMember.id,
    };

    if (newProduct.type === 'unsubscribe') {
      const { code, data } = await deleteReq({ url, requestHeaders, payload });
      let timeoutCode = code.toString();
      timeoutCode = Array.from(timeoutCode)[0];
      if (code === 200) {
        setIsDisabledBtn(false);

        toast.success(data?.message, {
          position: 'top-center',
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
        setEditMemberPopUp(false);
        getTeamMembers();
      } else if (timeoutCode === '5') {
        let newPayload = {
          memberId: editMember.id,
          code,
        };
        postLogger('REMOVE_TEAM_MEMBER', newPayload);
      }
    } else {
      const { code, data } = await postReq({ url, requestHeaders, payload });
      let timeoutCode = code.toString();
      timeoutCode = Array.from(timeoutCode)[0];

      let itemObj = {
        item_id: newProduct.product.id,
        item_name: newProduct.product.nickName,
        price: newProduct.product.price,
        quantity: 1,
      };

      if (code === 200 && data?.url) {
        setSessionStorage({
          key: 'product-info',
          value: {
            userId: profilesSession.userId,
            items: itemObj,
            currency: newProduct.product.currency,
            value: newProduct.product.price,
          },
        });
        window.location.replace(data.url);
      } else if (code === 200) {
        trackEvents('purchase', {
          userId: profilesSession.userId,
          items: itemObj,
          currency: newProduct.product.currency,
          value: newProduct.product.price,
        });
        //GTM event
        window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        window.dataLayer.push({
          event: 'purchase',
          user_id: profilesSession.userId,
          type: 'team_member',
          ecommerce: {
            currency: newProduct.product.currency,
            value: newProduct.product.price,
            items: [
              {
                item_id: newProduct.product.id,
                item_name: newProduct.product.nickName,
                price: newProduct.product.price,
                discount: 0.0,
                quantity: 1,
              },
            ],
          },
        });

        setIsDisabledBtn(false);
        toast.success(data?.message, {
          position: 'top-center',
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
        setEditMemberPopUp(false);
        getTeamMembers();
      } else if (timeoutCode === '5') {
        let newPayload = {
          memberId: editMember.id,
          code,
        };
        postLogger('REMOVE_TEAM_MEMBER', newPayload);
      }
    }
  };

  if (editMember && editMember.name) {
    return (
      <div className="account-wrapper">
        {/* <div
          className="bg-image"
          style={{
            backgroundImage: `url(${AccountBg})`,
            zIndex: '0',
            cursor: 'pointer',
          }}
        ></div> */}
        <div className="account-footer">
          <SSButton
            btnText={'BACK'}
            onClickHandle={() => {
              setEditMemberPopUp(false);
            }}
          />
          <SSButton
            btnText={'SAVE'}
            type={'filled'}
            onClickHandle={() => {
              updateProductsSubscription();
            }}
            isDisabled={isDisabledBtn}
          />
        </div>
        {/* <div className="header">
          <h1 className="popup-title">Team Member</h1>
          {profile.roleType === 'OWNER' ? (
            <h1
              className="popup-title red"
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                removeTeamMember();
              }}
            >
              remove from team
            </h1>
          ) : (
            ''
          )}
        </div> */}
        <div className="account-body">
          <div className="member-contact">
            <div className="name-avatar" translate="no">
              <Avatar
                name={editMember?.name}
                size="90px"
                round={true}
                color="white"
                maxInitials={1}
                textSizeRatio={2}
                style={{ fontWeight: '400', fontSize: '32px' }}
              />
            </div>
            <div className="details">
              <h1 translate="no">{editMember?.name}</h1>
              <p translate="no">{editMember?.email}</p>
              {profile.roleType === 'OWNER' ? (
                <span
                  translate="no"
                  className="remove"
                  style={{
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    removeTeamMember();
                  }}
                >
                  remove from team
                </span>
              ) : (
                ''
              )}
            </div>
          </div>
          <div className="member-seats">
            <div className="title">SUBSCRIBE MEMBERS TO</div>
            <div className="tools">
              {allPlans?.length &&
                allPlans.map((plan) => {
                  return (
                    <SSProductItem
                      key={plan.id}
                      isClicked={isToolActivated(plan.id)}
                      handleItemClicked={handleItemClicked}
                      product={plan}
                    />
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
